import { ESRI_DEFAULT_ICON_LABEL_FONT } from '../configurations';
import type { LabelClassProperties } from '../types';
import { colors } from '../../colors/colors';
import policeInactive from '../images/station-icons/police/police_station_inactive.svg';
import policeSelected from '../images/station-icons/police/police_station_selected.svg';
import fireInactive from '../images/station-icons/fire/fire_station_inactive.svg';
import fireSelected from '../images/station-icons/fire/fire_station_selected.svg';
import emsInactive from '../images/station-icons/ems/ems_station_inactive.svg';
import emsSelected from '../images/station-icons/ems/ems_station_selected.svg';

export const policeUniqueValueInfos = [
    {
        value: 'Police, Inactive',
        symbol: {
            type: 'picture-marker',
            url: policeInactive,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'Police, Selected',
        symbol: {
            type: 'picture-marker',
            url: policeSelected,
            width: '32px',
            height: '32px',
        },
    },
];

export const fireUniqueValueInfos = [
    {
        value: 'Fire, Inactive',
        symbol: {
            type: 'picture-marker',
            url: fireInactive,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'Fire, Selected',
        symbol: {
            type: 'picture-marker',
            url: fireSelected,
            width: '32px',
            height: '32px',
        },
    },
];

export const emsUniqueValueInfos = [
    {
        value: 'EMS, Inactive',
        symbol: {
            type: 'picture-marker',
            url: emsInactive,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: 'EMS, Selected',
        symbol: {
            type: 'picture-marker',
            url: emsSelected,
            width: '32px',
            height: '32px',
        },
    },
];

export const stationIconRenderer = {
    type: 'unique-value', // autocasts as new UniqueValueRenderer()
    field: 'iconName',
    defaultSymbol: {
        // used when item field dont match anything defined in uniqueValueInfos
        type: 'simple-marker',
        style: 'square',
        color: colors.mapLabelDefault,
        size: '32px',
    },
    uniqueValueInfos: [...policeUniqueValueInfos, ...emsUniqueValueInfos, ...fireUniqueValueInfos],
    authoringInfo: undefined,
};

const inactiveStationIconLabel: LabelClassProperties = {
    symbol: {
        type: 'text',
        color: colors.mapLabelText,
        haloColor: colors.mapLabelHalo,
        haloSize: '1px',
        xoffset: '-4px',
        font: ESRI_DEFAULT_ICON_LABEL_FONT,
    },
    labelPlacement: 'center-right',
    labelExpressionInfo: {
        expression: `$feature.stationName`,
    },
    maxScale: 0,
    minScale: 25000000,
    where: `uiState<>'Selected'`,
};

const selectedStationIconLabel: LabelClassProperties = {
    symbol: {
        type: 'text',
        color: colors.mapLabelAlert,
        haloColor: colors.mapLabelHalo,
        haloSize: '1px',
        xoffset: '-4px',
        font: ESRI_DEFAULT_ICON_LABEL_FONT,
    },
    labelPlacement: 'center-right',
    labelExpressionInfo: {
        expression: `$feature.stationName`,
    },
    maxScale: 0,
    minScale: 25000000,
    where: `uiState='Selected'`,
};

export const stationIconLabels = [inactiveStationIconLabel, selectedStationIconLabel];
